import type { IconName } from "@similarweb/icons";

import { SitesAppsLegend } from "../../../../../components/Legends/src/SitesAppsLegend/SitesAppsLegend";
import { useTrack } from "../../../../../components/WithTrack/src/useTrack";
import { useTranslation } from "../../../../../components/WithTranslation/src/I18n";
import { StyledBoxLink, SWGroupsTilesContainer, TemporaryBox, Title } from "../StyledComponents";

interface ISite {
    iconName: IconName;
    iconSrc: string;
}

export interface IGroupTile {
    title: string;
    iconName: string;
    sites: ISite[];
    onClick?: () => void;
}

interface ISWGroupTilesProps {
    tilesProps: IGroupTile[];
}

export const SWGroupTiles = ({ tilesProps }: ISWGroupTilesProps) => {
    const [track] = useTrack();
    const translate = useTranslation();
    const trackLink = (title: string) => track("Internal Link", "click", title);

    return (
        <SWGroupsTilesContainer>
            {tilesProps.map((props, index) => {
                const handleClick = () => {
                    trackLink(props.title);
                    if (props.onClick && typeof props.onClick === "function") {
                        props.onClick();
                    }
                };

                return (
                    <StyledBoxLink
                        key={`${index}_${props.title}`}
                        onClick={handleClick}
                    >
                        <TemporaryBox key={"tile" + index}>
                            <Title>{props.title}</Title>
                            <SitesAppsLegend
                                type="websites"
                                items={props.sites}
                                translate={translate}
                            />
                        </TemporaryBox>
                    </StyledBoxLink>
                );
            })}
        </SWGroupsTilesContainer>
    );
};
